import { render, staticRenderFns } from "./ExportPpt.vue?vue&type=template&id=3bd3e3ba&scoped=true"
import script from "./ExportPpt.vue?vue&type=script&lang=js"
export * from "./ExportPpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd3e3ba",
  null
  
)

export default component.exports